// import { h } from 'vue';
import axios from "axios";
import { Message } from "element-ui";

import { qsParse } from '@/utils/qs';
import { filterObjWithValidValue } from '@/api/url';
import { getType } from '@/utils/base';
import { getXTSessionid } from "@/utils/project";
import md5 from "js-md5";

// 创建实例
const request = axios.create({
  timeout: 60000
});

// 请求拦截器
request.interceptors.request.use(
  (req) => {
    const isFormData = typeof FormData !== "undefined" && req.data instanceof FormData;
    req.headers = {
      "token2": localStorage.getItem("token2"),
      'USER-TOKEN': 'skip',
      'deviceId': localStorage.getItem('device_id'),
      "x-t-sessionid": getXTSessionid(),
      "X-Request-Id": md5(new Date().getTime() + "-" + Math.random()),
    };
    if (!isFormData) req.headers["Content-Type"] = "application/json";

    // 使用链接上的token （用于不登录直接访问的页面）
    // https://wisdomcloud-test.heiniubao.cn/preview/mttf/zx-to-mofang?token=FisLPbXDTWWkIpwe68JfeTHaplWNKv6
    const query = qsParse();
    if (query.token) req.headers.token2 = query.token;

    // 小蓝表
    const blueToken = localStorage.getItem('blueToken');
    if (blueToken) req.headers.token2 = blueToken;
    if (req.url.includes('policy/rbLogin')) req.headers.scene = 'zhibaoyun';

    return req;
  },
  (err) => {
    console.error('request-error =>', err);
    return Promise.reject(err);
  },
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // console.log('response', response);
    const {data, config, status} = response;

    if (status >= 200 && status < 300) {
      if (getType(data) !== 'object') return response;

      const {code, message} = data;
      const {url} = config;

      if (code === "666666") {
        Message.closeAll();
        Message.warning({ message: "登录超时"});
        clearLogin();
        window.location.replace(`/login?redirectUrl=${encodeURIComponent(window.location.href)}`);
      }
      if (!['000000', '666666'].includes(code)) allowToast(url, () => {Message.error({message, customClass: 'el-message-' + url.split('/').pop()});})
      return response;
    } else {
      console.error('response-error1 =>', response);
      return Promise.reject(response);
    }
  },
  (axiosError) => {
    console.error('response-error2 =>', axiosError);
    // const { response, config } = axiosError;
    return Promise.reject(axiosError);
  },
);

export function get(url, params = {}, options = {}) {
  return request({
    method: 'GET',
    url,
    params: options.noValid ? params : filterObjWithValidValue(params),
    ...options
  })
    .then((response) => {
      // console.log(url, response);
      // const simpleUrl = url.split('?')[0];
      // console.groupCollapsed(`%c get => ${simpleUrl}`, 'color: red;');
      // console.log('%c req =>', 'color: red;', params);
      // console.log('%c res =>', 'color: red;', copy(response.data));
      // console.groupEnd();
      return options.needOrigin ? response : response.data;
    })
    .catch((err) => {
      // console.error('request-get-err =>', err);
      toastError(url, err);
      return Promise.reject(err);
    });
}

export function post(url, data = {}, options = {}) {
  let body = filterObjWithValidValue(data);
  if (options.noValid) body = data;
  if (options.isFormData){
    const formData = new FormData();
    if (Object.prototype.toString.call(data) === '[object Object]') {
      for (let k in data) {
        formData.append(k, data[k]);
      }
    }
    body = formData;
  }

  return request({
    method: 'POST',
    url,
    data: body,
    ...options,
  })
    .then((response) => {
      // console.log(url, response);
      // const simpleUrl = url.split('?')[0];
      // console.groupCollapsed(`%c post => ${simpleUrl}`, 'color: red;');
      // console.log('%c req =>', 'color: red;', data);
      // console.log('%c res =>', 'color: red;', copy(response.data));
      // console.groupEnd();
      return options.needOrigin ? response : response.data;
    })
    .catch((err) => {
      // console.error('request-post-err =>', err);
      toastError(url, err);
      return Promise.reject(err);
    });
}


// export function post2(url, params={}, options={}){
//   return request({
//     method: "POST",
//     url,
//     data: filterObjWithValidValue(params),
//     ...options,
//   })
//     .then((response) => {
//       return response;
//     })
//     .catch((err) => {
//       toastError(url, err);
//       return Promise.reject(err);
//     });
// }

export function jsonp(options = {}, callback = function () {}) {
  const { url, jsonp, data } = options;
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");

    const callbackName = `hn_${Date.now()}`; //回调方法名
    window[callbackName] = function (response) {
      console.log("response", response);
      resolve(response);
      callback(null, response);
      delete window[callbackName];
      document.head.removeChild(script);
    };

    let queryString = url.indexOf("?") === -1 ? "?" : "&";
    for (let key in data) {
      queryString += `${key}=${data[key]}&`;
    }
    const newUrl = `${url}${queryString}${jsonp}=${callbackName}`;
    console.log('jsonp-url =>', newUrl.slice(6));
    script.src = newUrl;
    document.head.appendChild(script);
  });
}

// 处理错误信息提示
export function toastError(url, err) {
  const stopUrls = [
    'robotAccount/save/recording',
  ]
  const isStop = stopUrls.some(item => url.includes(item));
  if (!isStop){
    Message.error(err.message || '服务超时,请稍后重试');
  }

  // try {
  //   const errStr = JSON.stringify(err);
  //   if (errStr === '{}') {
  //     Message.error(err.message);
  //   } else {
  //     MessageBox({
  //       title: '报错啦，请联系客服人员进行咨询',
  //       message: h('p', null, [
  //         h('span', { style: 'white-space: pre-wrap; word-break: break-word;' }, errStr)
  //       ]),
  //       confirmButtonText: '复制错误信息'
  //     }).then(() => copyText(errStr));
  //   }
  // } catch (error) {
  //   Message.error(err.message);
  // }
}

// 允许弹窗提示
export function allowToast(url, callack){
  const stopUrls = [
    'callRecord/queryAgent',
    'robotAccount/save/recording',
  ]
  const isStop = stopUrls.some(item => url.includes(item));
  if (!isStop) callack();
}

// 清除登录态
export function clearLogin(){
  localStorage.removeItem('token');
  localStorage.removeItem('token2');
  localStorage.removeItem('blueToken');
  localStorage.removeItem('menuList');
  localStorage.removeItem('userInfo');
}

export default request;

